export class Enum {
    constructor (public id: number, public value: string) {}
}
